export default "/images/cea.svg?611fb14fa1086f3d7bd14d32ad231e62";